import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { getServiceCategories } from './service-categories-actions';
import {
  ELECTRIC_UNDERFLOOR_HEATING,
  FETCH_SERVICE_CATEGORIES,
  ROUGH_REPAIR,
  ROUGH_REPAIR_REGION_LIST,
  SERVICE_CATEGORIES_STORE_NAME,
} from './service-categories-constants';
import { ServiceCategoriesStore } from './service-categories-types';

const INITIAL_STATE: ServiceCategoriesStore = {
  serviceCategoriesList: null,
  loading: false,
  error: null,
} as const;

export const serviceCategories = (parentStore: Store) => {
  const store = createSubstore(parentStore, SERVICE_CATEGORIES_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_SERVICE_CATEGORIES.init, async () => {
    const { loading } = store.get();
    const { modelJson } = parentStore.get();
    if (!modelJson.model || loading) {
      return Promise.resolve();
    }
    store.dispatch(FETCH_SERVICE_CATEGORIES.request);

    try {
      const regionId = modelJson.model.properties.regionId;
      const serviceCategoriesList = await getServiceCategories(parentStore, regionId);
      const enchancedServiceList = [...serviceCategoriesList, ELECTRIC_UNDERFLOOR_HEATING];
      store.dispatch(
        FETCH_SERVICE_CATEGORIES.success,
        ROUGH_REPAIR_REGION_LIST.includes(regionId)
          ? [...enchancedServiceList, ROUGH_REPAIR]
          : enchancedServiceList
      );
    } catch (e) {
      store.dispatch(FETCH_SERVICE_CATEGORIES.failure, (e as Error).message);
    }

    return Promise.resolve();
  });
  store.on(FETCH_SERVICE_CATEGORIES.request, state => ({ ...state, loading: true }));
  store.on(FETCH_SERVICE_CATEGORIES.failure, (state, error) => ({
    ...state,
    error,
    loading: false,
    serviceCategoriesList: null,
  }));
  store.on(FETCH_SERVICE_CATEGORIES.success, (state, res) => ({
    ...state,
    serviceCategoriesList: res,
    loading: false,
  }));
};
